import { getAssetUrl } from '@/utils/common';

export const qrCodeList = [
  {
    id: 'cbf13b76-1121-4182-9fe4-13547a565a48',
    image: getAssetUrl('images/route/listImgs/白居易.png'),
    label: '白居易',
    name: '乐天吟踪 西湖诗旅',
    theme: '乐天吟踪\n西湖诗旅',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-05/8e5f7f86-7058-4398-9819-4113f299f74b.jpg'
  },
  {
    id: '',
    image: getAssetUrl('images/route/listImgs/西泠印社与西湖.png'),
    name: '西泠印社与西湖',
    theme: '西泠印社\n与西湖',
  },
  {
    id: '',
    image: '',
    name: '杭州西湖地图页',
    theme: '杭州西湖\n地图页',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-06/8125c599-b53e-4ac5-a438-5b6926e6fd73.jpg'
  },
  {
    id: 'f452eb91-427e-4162-abca-295de0d955da',
    image: getAssetUrl('images/route/listImgs/西湖边的名人故居.png'),
    name: '西湖边的名人故居',
    theme: '西湖边的\n名人故居',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/ac5874fa-5b3d-45f9-a972-19234eb5e4b8.jpg'
  },
  {
    id: '2bc037a8-185a-40ac-bf40-b1a040d7d3d9',
    image: getAssetUrl('images/route/listImgs/语文课本中的西湖.png'),
    name: '语文课本中的西湖',
    theme: '语文课本\n中的西湖',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/461a31ef-872c-4fb4-853d-6709f436723b.jpg'
  },
  {
    id: '48ab9cb3-626c-4672-ab96-d8e6fea31ebc',
    image: getAssetUrl('images/route/listImgs/《水浒》中的西湖.png'),
    name: '《水浒》中的西湖',
    theme: '《水浒》中\n的西湖',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/93d345aa-5a02-4a4f-8790-1e166cd62aa6.jpg'
  },
  {
    id: '',
    image: '',
    name: '当西湖遇上楹联',
    theme: '当西湖遇\n上楹联',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/d22e1fb0-f94b-4303-8811-b01b5683e5de.jpg'
  },
  {
    id: '761c5a49-3d00-407e-892a-6df814ce6f65',
    image: getAssetUrl('images/route/listImgs/西湖边的民族气节.png'),
    name: '西湖边的民族气节',
    theme: '西湖边的\n民族气节',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/75ddc63c-cbc5-4084-bd92-2257e0393323.jpg'
  },
  {
    id: 'd74b0a7e-b894-496b-8372-c0668327aeae',
    image: getAssetUrl('images/route/listImgs/林逋.png'),
    label: '林逋',
    name: '和靖隐逸 西湖寻踪',
    theme: '和靖隐逸\n西湖寻踪',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/99c6fcfd-1f7f-4e3b-8fc0-64d1852a5de9.jpg'
  },
  {
    id: '4a633e8d-4652-4e77-a1aa-e586c621fbef',
    image: getAssetUrl('images/route/listImgs/钱镠.png'),
    label: '钱镠',
    name: '钱王巡湖 吴越揽胜',
    theme: '钱王巡湖\n吴越揽胜',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/4489acc5-2908-4f01-bdc3-59f4b263adf4.jpg'
  },
  {
    id: 'cbc5d441-64d0-4800-8c99-a827b1970551',
    image: getAssetUrl('images/route/listImgs/王旭烽.png'),
    label: '王旭烽',
    name: '旭烽叙事 灵性西湖',
    theme: '旭烽叙事\n灵性西湖',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/a38a349d-3098-4bf0-8fba-45345c633fb6.jpg'
  },
  {
    id: '72aa8351-7431-42b3-b71b-c4926f4ef7d9',
    image: getAssetUrl('images/route/listImgs/巴金.png'),
    label: '巴金',
    name: '巴金墨迹 西湖随想',
    theme: '巴金墨迹\n西湖随想',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/3fab6c1a-ea5d-47d1-b093-da3803b2b557.jpg'
  },
  {
    id: '38de4da0-d5f2-4905-89cf-af4dde8d81de',
    image: getAssetUrl('images/route/listImgs/冯雪峰.png'),
    label: '冯雪峰',
    name: '诗人雪峰 新诗西湖',
    theme: '诗人雪峰\n新诗西湖',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/e8cb5667-79f5-41bd-bda8-535768e98ebb.jpg'
  },
  {
    id: '',
    image: '',
    name: '翔宇之情 情满西湖',
    theme: '翔宇之情\n情满西湖',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/8d74d967-c138-4f58-b3c6-eba958d902cb.jpg'
  },
  {
    id: 'be822830-c504-423a-b7a9-1b22aa1ac991',
    image: getAssetUrl('images/route/listImgs/郁达夫.png'),
    label: '郁达夫',
    name: '湖山诗痕 西湖郁文',
    theme: '湖山诗痕\n西湖郁文',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/24b96d02-e1c7-4a15-9d81-0ba41b0c8612.jpg'
  },
  {
    id: '',
    image: '',
    name: '伟人诗路 润之西湖',
    theme: '伟人诗路\n润之西湖',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/ab142540-cb47-4bae-a9ea-bde14e8c8676.jpg'
  },
  {
    id: '22c5250f-e71d-4b06-af2d-37a30cf03a8c',
    image: getAssetUrl('images/route/listImgs/马一浮.png'),
    label: '马一浮',
    name: '湛翁书艺 墨韵湖山',
    theme: '湛翁书艺\n墨韵湖山',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/4c3a176c-2fc0-4f50-9d9e-82a9346d53ac.jpg'
  },
  {
    id: '1df30440-3e96-41fa-a855-ba001a37a99b',
    image: getAssetUrl('images/route/listImgs/鲁迅.png'),
    label: '鲁迅',
    name: '鲁迅寻痕 湖山风骨',
    theme: '鲁迅寻痕\n湖山风骨',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/c9da7b70-accd-47b0-b3be-b6e5b8ee8602.jpg'
  },
  {
    id: '1c13924c-b684-4663-bbe9-655714e8dcb6',
    image: getAssetUrl('images/route/listImgs/李叔同.png'),
    label: '李叔同',
    name: '弘一归处 禅意西湖',
    theme: '弘一归处\n禅意西湖',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/284c09bb-3001-41f8-b268-9bd7419e32ae.jpg'
  },
  {
    id: 'bf533c32-2116-480b-bed2-b7be1af9d491',
    image: getAssetUrl('images/route/listImgs/张岱.png'),
    label: '张岱',
    name: '陶庵梦寻 西湖文踪',
    theme: '陶庵梦寻\n西湖文踪',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-09/5bce5a9e-92b0-44ea-a9b4-724f0fd77ede.jpg'
  },
  {
    id: '0282bdcc-2dda-401f-a607-dcd35f12820a',
    image: getAssetUrl('images/route/listImgs/于谦.png'),
    label: '于谦',
    name: '忠肃遗痕  清白西湖',
    theme: '忠肃遗痕\n清白西湖',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-10/ee8c0fdf-4d83-422d-9a53-bcabefa7d1ef.jpg'
  },
  {
    id: '908a2a46-f4cc-4d9e-9dae-96cf087ec4e4',
    image: getAssetUrl('images/route/listImgs/陆游.png'),
    label: '陆游',
    name: '放翁诗路 湖山侠情',
    theme: '放翁诗路\n湖山侠情',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-10/d27912da-d262-475f-8b68-362161b4c8ca.jpg'
  },
  {
    id: '55ab1996-c0c5-45a4-bb89-f64396caff85',
    image: getAssetUrl('images/route/listImgs/岳飞.png'),
    label: '岳飞',
    name: '武穆诗途 浩气西湖',
    theme: '武穆诗途\n浩气西湖',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-10/e998010b-8f6f-4430-8532-9d2f50e0bce7.jpg'
  },
  {
    id: '2dd91f15-be33-480d-bbb4-56e45f5868c1',
    image: getAssetUrl('images/route/listImgs/苏轼.png'),
    label: '苏轼',
    name: '子瞻吟咏 西湖天下',
    theme: '子瞻吟咏\n西湖天下',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-10/565b99b5-03a7-4008-ba48-ec4ef0bbdf71.jpg'
  },
  {
    id: '1ba49730-0b09-41b1-a119-6e239db7ccec',
    image: getAssetUrl('images/route/listImgs/范仲淹.png'),
    label: '范仲淹',
    name: '希文知州 长忆西湖',
    theme: '希文知州\n长忆西湖',
    url: 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/shuyou/weixin/qrCode/2025-06-10/9bde2025-f140-40e1-8c0d-174e287e8e0b.jpg'
  }
];



